{
  "tabs": {
    "period": "Hoa hồng",
    "sheets": "Phiếu hoa hồng",
    "rules": "Quy tắc hoa hồng"
  },
  "table": {
    "accrued": "Tạm tính",
    "locked": "Đã chốt",
    "paid": "Đã chi",
    "totalCommission": "Tổng hoa hồng"
  },
  "pages": {
    "tabsAria": "Hoa hồng người giới thiệu"
  },
  "basis": {
    "per_chart": "Cố định theo hồ sơ",
    "collected": "Doanh thu đã thu",
    "contracted_payable": "Doanh số phải thu"
  },
  "formula": {
    "percent": "Phần trăm",
    "fixed": "Số tiền cố định"
  },
  "status": {
    "draft": "Nháp",
    "active": "Đang áp dụng",
    "inactive": "Đã tắt",
    "accrued": "Tạm tính",
    "locked": "Đã chốt",
    "paid": "Đã chi",
    "void": "Hủy",
    "open": "Đang mở",
    "closed": "Đã đóng"
  },
  "fields": {
    "name": "Tên quy tắc",
    "basisType": "Cách tính",
    "formulaType": "Công thức",
    "value": "Giá trị",
    "priority": "Độ ưu tiên",
    "startDate": "Ngày bắt đầu",
    "endDate": "Ngày kết thúc",
    "status": "Trạng thái",
    "period": "Kỳ",
    "paymentMethod": "Hình thức chi",
    "referrer": "Người giới thiệu",
    "referrers": "Người giới thiệu áp dụng",
    "clinics": "Phòng khám",
    "referrerKinds": "Loại người giới thiệu",
    "catalogIds": "Dịch vụ",
    "categoryIds": "Nhóm dịch vụ",
    "amount": "Hoa hồng",
    "basisAmount": "Cơ sở",
    "createdAt": "Ngày tạo",
    "createdBy": "Người tạo",
    "updatedAt": "Ngày chỉnh sửa",
    "editedBy": "Người chỉnh sửa"
  },
  "placeholders": {
    "search": "Tìm tên quy tắc",
    "searchReferrer": "Tìm tên người giới thiệu",
    "name": "Ví dụ: Hoa hồng đối tác 5%",
    "value": "Ví dụ: 5",
    "period": "YYYY-MM",
    "clinics": "Chọn phòng khám (để trống = tất cả)",
    "referrerKinds": "Chọn loại (để trống = tất cả)",
    "referrers": "Gõ tên hoặc SĐT để tìm người giới thiệu",
    "catalogs": "Chọn dịch vụ (để trống = tất cả)",
    "categories": "Chọn nhóm (để trống = tất cả)"
  },
  "sections": {
    "serviceScope": "Phạm vi dịch vụ (chỉ áp dụng khi tính theo doanh thu hoặc doanh số)"
  },
  "scope": {
    "allClinics": "Tất cả phòng khám",
    "allKinds": "Tất cả loại",
    "allReferrers": "Tất cả người giới thiệu",
    "allServices": "Tất cả dịch vụ",
    "allCategories": "Tất cả nhóm dịch vụ",
    "referrerCount": "{{count}} người",
    "clinicScoped": "Áp dụng cho phòng khám đang chọn trên thanh"
  },
  "referrerKinds": {
    "patient": "Bệnh nhân",
    "staff": "Nhân viên",
    "external": "Đối tác"
  },
  "validation": {
    "value": "Nhập giá trị từ 0 trở lên",
    "startDate": "Chọn ngày bắt đầu"
  },
  "actions": {
    "addRule": "Thêm quy tắc",
    "editRule": "Sửa quy tắc hoa hồng người giới thiệu",
    "lock": "Chốt kỳ",
    "locking": "Đang chốt...",
    "unlock": "Mở khóa",
    "unlocking": "Đang mở khóa...",
    "openPeriod": "Mở kỳ",
    "openingPeriod": "Đang mở kỳ...",
    "reopen": "Mở lại",
    "reopening": "Đang mở lại...",
    "pay": "Chi",
    "paying": "Đang chi...",
    "deactivate": "Tắt quy tắc",
    "deactivating": "Đang tắt...",
    "history": "Lịch sử",
    "selectAllLocked": "Chọn tất cả phiếu đã chốt"
  },
  "history": {
    "ruleTitle": "Lịch sử quy tắc hoa hồng",
    "ruleEmpty": "Chưa có lịch sử cho quy tắc này."
  },
  "confirms": {
    "deactivateTitle": "Tắt quy tắc",
    "deactivateMessage": "Tắt quy tắc \"{{name}}\"? Quy tắc không còn được áp dụng.",
    "lock": "Chốt {{count}} dòng tạm tính của kỳ {{period}}? Sau khi chốt, số tiền không đổi cho đến khi mở khóa.",
    "lockEmpty": "Chốt kỳ {{period}} dù chưa có dòng tạm tính? Kỳ sẽ khóa nhận thêm hoa hồng cho đến khi mở khóa.",
    "unlock": "Mở khóa {{count}} dòng đã chốt của kỳ {{period}}? Các dòng chưa chi sẽ về tạm tính."
  },
  "hints": {
    "consumedInPayroll": "Một số dòng đã gộp vào bảng lương. Không mở khóa hoặc chi riêng được cho các dòng đó."
  },
  "errors": {
    "REFERRAL_COMMISSION_ALREADY_CONSUMED": "Hoa hồng giới thiệu đã gộp vào bảng lương, không chi hoặc mở khóa riêng được.",
    "REFERRAL_COMMISSION_PERIOD_NOT_LOCKED": "Kỳ chưa chốt. Chốt kỳ trước khi chi."
  },
  "empty": {
    "rules": "Chưa có quy tắc hoa hồng giới thiệu",
    "search": "Không có quy tắc khớp tên đã nhập",
    "searchReferrer": "Không có người giới thiệu khớp tên đã nhập",
    "entries": "Chưa có dòng hoa hồng trong kỳ này",
    "summary": "Chưa có phiếu hoa hồng trong kỳ này"
  },
  "toasts": {
    "saveFailed": "Không lưu được quy tắc",
    "createSuccess": "Đã tạo quy tắc",
    "updateSuccess": "Đã cập nhật quy tắc",
    "deactivateSuccess": "Đã tắt quy tắc",
    "lockSuccess": "Đã chốt {{count}} dòng hoa hồng",
    "lockSealed": "Đã chốt kỳ {{period}}",
    "unlockSuccess": "Đã mở khóa kỳ",
    "reopenSuccess": "Đã mở kỳ",
    "paySuccess": "Đã chi hoa hồng giới thiệu",
    "actionFailed": "Không thực hiện được",
    "needClinic": "Chọn một phòng khám trên thanh để chốt hoặc chi"
  },
  "pay": {
    "title": "Chi hoa hồng giới thiệu",
    "selectRows": "Chọn dòng đã chốt để chi"
  }
}
